import { render, staticRenderFns } from "./FundComments.vue?vue&type=template&id=016313a8&scoped=true&"
import script from "./FundComments.vue?vue&type=script&lang=js&"
export * from "./FundComments.vue?vue&type=script&lang=js&"
import style0 from "./FundComments.vue?vue&type=style&index=0&id=016313a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016313a8",
  null
  
)

export default component.exports